import "bootstrap/dist/css/bootstrap.min.css";
import {  Image } from "react-bootstrap";
import { MESSAGE } from '../../../utils/message';
import LS_Image_one from "../../../assests/images/ls-page-image/ls-left-upper-img.webp";
import LS_Image_two from "../../../assests/images/ls-page-image/ls-right-upper-img.webp";
import LS_Image_three from "../../../assests/images/ls-page-image/ls-right-bottom-img.webp";
import Login_user_icon from "../../../assests/images/ls-page-image/login-user-blue.svg";
import Login_Visitors_icon from "../../../assests/images/ls-page-image/login-visitors.svg";
import stay_up_to_date_icon from "../../../assests/images/ls-page-image/stay-up-to-date-icon.svg";
import Fundraisers_Support_Nonprofits_Icon from "../../../assests/images/ls-page-image/fundraisers-support-nonprofits-icon.svg";
import Say_Stories_Influence_Icon from "../../../assests/images/ls-page-image/say-stories-influence-icon.svg";
import {
    GreatNonprofitsMain,
    GreatNonprofitsInner,
    GreatNonprofitsTitle,
    GreatNonprofitsBox,
    GreatNonprofitsBoxLeft,
    GreatNonprofitsImageLeft,
    GreatNonprofitsBoxRight,
    GreatNonprofitsImageRight, 
    BackBlueBox,
    BackWhiteIcon,
    BoxText,  
    BoxNumber,
    SingUPLeftBox,
} from "./authLogoCardStyle";

interface InfoBoxProps {
    icon?: string;
    number?: string;
    text: string;
    className?: string;
    style?: React.CSSProperties;
}

const InfoBox: React.FC<InfoBoxProps> = ({ icon, number, text, className = "", style = {} }) => (
    <BackBlueBox className={className} style={style}>
        {icon && (
            <BackWhiteIcon className="icon-back-white">
                <Image src={icon} alt="icon" width="36" height="36" />
            </BackWhiteIcon>
        )}
        <BoxText>
            {number && <BoxNumber>{number}</BoxNumber>}
            {text}
        </BoxText>
    </BackBlueBox>
);

interface AuthLogoCardProps {
    userType: string;
}

const AuthLogoCard: React.FC<AuthLogoCardProps> = ({ userType }) => {
    const isIndividual = userType === "individual";
    const isNonprofit = userType === "nonprofit";
    const isIndvidualOrNonProfit = isIndividual || isNonprofit;
    const isAuthUser = userType === "AuthUser";

    return (
        <GreatNonprofitsMain>
            <GreatNonprofitsInner className={isIndvidualOrNonProfit ? 'sing-up-mb-new' : ''}>
                <GreatNonprofitsTitle className={isAuthUser ? 'sing-up-mr-new' : ''}>
                    {MESSAGE.loginTitle}
                </GreatNonprofitsTitle>
                <GreatNonprofitsTitle className={isIndvidualOrNonProfit ? 'sing-up-mb-new1' : ''}>
                    {MESSAGE.signupTitle}
                </GreatNonprofitsTitle>
                <GreatNonprofitsBox>
                    <GreatNonprofitsBoxLeft>
                        <GreatNonprofitsImageLeft>
                            <Image src={LS_Image_one} alt="Login-sing-up-images" width="250" height="335" />
                            <InfoBox
                                icon={Login_user_icon}
                                number="300,000"
                                text="Users"
                                className={`ls-pr blue-box ${isAuthUser ? 'login-box-one' : ''}`}
                            />
                            <SingUPLeftBox>
                                {isIndividual && (
                                    <InfoBox
                                        icon={stay_up_to_date_icon}
                                        text="Stay Up-to-Date on Your Favorite Nonprofit Organizations"
                                        className={`ls-pr blue-box individual-box-one`}
                                    />
                                )}
                                {isNonprofit && (
                                    <InfoBox
                                        icon={Say_Stories_Influence_Icon}
                                        number="80% of Donors"
                                        text="Say Stories Influence their Giving"
                                        className={`ls-pr blue-box individual-box-one blue-box-w`}
                                    />
                                )}
                            </SingUPLeftBox>
                        </GreatNonprofitsImageLeft>
                    </GreatNonprofitsBoxLeft>
                    <GreatNonprofitsBoxRight className={isAuthUser ? 'sing-up-mrt-new' : ''}>
                        <GreatNonprofitsImageRight>
                            <Image src={LS_Image_three} alt="Login-sing-up-images" width="220" height="210" />
                            <InfoBox
                                number="30,000"
                                text="Nonprofits"
                                className={`ls-pr multi-color-box ${isAuthUser ? 'login-box-two' : ''}`}
                            />
                            <SingUPLeftBox>
                                {isIndividual && (
                                    <InfoBox
                                        text="Edit & Manage Your NonProfits Stories"
                                        className={`ls-pr multi-color-box individual-box-two`}
                                    />
                                )}
                                {isNonprofit && (
                                    <InfoBox
                                        number="81% of Donors"
                                        text="Say Stories Help Decide Where to Volunteer"
                                        className={`ls-pr multi-color-box box-text-left individual-box-two`}
                                    />
                                )}
                            </SingUPLeftBox>
                        </GreatNonprofitsImageRight>
                        <GreatNonprofitsImageRight>
                            <Image src={LS_Image_two} alt="Login-sing-up-images" width="220" height="165" />
                            <InfoBox
                                icon={Login_Visitors_icon}
                                number="20,000,000"
                                text="Visitors"
                                className={`ls-pr white-box ${isAuthUser ? 'login-box-Three' : ''}`}
                            />
                            <SingUPLeftBox>
                                {isIndividual && (
                                    <InfoBox
                                        icon={Fundraisers_Support_Nonprofits_Icon}
                                        text="Create Fundraisers to Support Nonprofits You Care About"
                                        className={`ls-pr blue-box individual-box-three`}
                                    />
                                )}
                                {isIndividual && (
                                    <InfoBox
                                        icon={Login_Visitors_icon}
                                        text="Save a List of Your Favorite Nonprofits"
                                        className={`ls-pr white-box individual-box-four`}
                                    /> 
                                )}
                                {isNonprofit && (
                                    <InfoBox
                                        icon={Login_Visitors_icon}
                                        number="90% of Donors"
                                        text="Say Stories Help them Understand a NonProfit's Mission"
                                        className={`ls-pr white-box individual-box-five`}
                                    />
                                )}
                            </SingUPLeftBox>
                        </GreatNonprofitsImageRight>
                    </GreatNonprofitsBoxRight>
                </GreatNonprofitsBox>
            </GreatNonprofitsInner>
        </GreatNonprofitsMain>
    );
};

export default AuthLogoCard;